'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var index = require('../node_modules/prop-types/index.js');
var clsx_m = require('../node_modules/clsx/dist/clsx.m.js');
var styles = require('@material-ui/styles');
var Tooltip = require('@material-ui/core/Tooltip');
var ButtonBase = require('@material-ui/core/ButtonBase');
var OptionsIcon = require('@material-ui/icons/MoreHorizRounded');
var core = require('@material-ui/core');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
var ButtonBase__default = /*#__PURE__*/_interopDefaultLegacy(ButtonBase);
var OptionsIcon__default = /*#__PURE__*/_interopDefaultLegacy(OptionsIcon);

var _excluded = ["show", "actions", "children"];
var useStyles = styles.makeStyles(theme => ({
  root: {
    position: 'relative',
    boxSizing: 'border-box'
  },
  button: {
    flex: 1,
    width: 34,
    fontSize: 14,
    color: theme.palette.action.active,
    padding: "4px 8px",
    boxSizing: 'border-box'
  },
  optionsButton: {
    borderTopRightRadius: 999,
    borderBottomRightRadius: 999
  },
  actionsContainer: {
    backgroundColor: theme.palette.common.white,
    opacity: props => props.shouldShow ? 1 : 0,
    boxShadow: props => props.shouldShow ? '0 2px 10px 0 rgb(21 27 38 / 10%)' : 'none',
    display: props => props.shouldShow ? 'flex' : 'none',
    position: 'absolute',
    right: 0,
    transition: theme.transitions.create('opacity'),
    borderRadius: 999,
    overflow: 'hidden',
    border: "1px solid ".concat(theme.palette.divider),
    boxSizing: 'border-box'
  },
  actionButton: {
    flex: 1,
    borderRight: "1px solid ".concat(theme.palette.divider)
  },
  menu: {
    marginTop: 8
  }
}));
function OptionsButtonMenu(_ref) {
  var {
    show = false,
    actions,
    children
  } = _ref;
      _rollupPluginBabelHelpers.objectWithoutProperties(_ref, _excluded);

  var [menuAnchor, setMenuAnchor] = React__namespace.useState(null);
  var [isHovering, setIsHovering] = React__namespace.useState(false);
  var classes = useStyles({
    shouldShow: show || isHovering || Boolean(menuAnchor)
  });
  var handleCloseMenu = React__namespace.useCallback(event => {
    event.stopPropagation();
    setMenuAnchor(null);
  }, []);
  var handleOpenMenu = React__namespace.useCallback(event => {
    event.stopPropagation();
    setMenuAnchor(event.currentTarget);
  }, []);
  var handleMouseEnter = React__namespace.useCallback(() => {
    setIsHovering(true);
  }, []);
  var handleMouseLeave = React__namespace.useCallback(() => {
    setIsHovering(false);
  }, []);

  function handleContainerClick(event) {
    event.stopPropagation();
  }

  return /*#__PURE__*/React__namespace.createElement(React__namespace.Fragment, null, /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.root,
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    onClick: handleContainerClick,
    onKeyPress: handleContainerClick,
    role: "button",
    tabIndex: 0
  }, /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.actionsContainer
  }, actions.map((action, index) => /*#__PURE__*/React__namespace.createElement(Tooltip__default['default'], {
    key: index,
    title: action.title
  }, /*#__PURE__*/React__namespace.createElement(ButtonBase__default['default'], {
    key: index,
    className: clsx_m(classes.actionButton, classes.button),
    onClick: action.onClick
  }, action.icon))), /*#__PURE__*/React__namespace.createElement("div", {
    className: classes.button
  })), /*#__PURE__*/React__namespace.createElement(ButtonBase__default['default'], {
    className: clsx_m(classes.button, classes.optionsButton),
    onClick: handleOpenMenu
  }, /*#__PURE__*/React__namespace.createElement(OptionsIcon__default['default'], null)), /*#__PURE__*/React__namespace.createElement(core.Menu, {
    className: classes.menu,
    open: Boolean(menuAnchor),
    onClose: handleCloseMenu,
    anchorEl: menuAnchor,
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    },
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    }
  }, children)));
}
OptionsButtonMenu.propTypes = {
  actions: index.arrayOf(index.shape({
    title: index.string,
    icon: index.node,
    onClick: index.func
  }))
};

exports.OptionsButtonMenu = OptionsButtonMenu;
